export default __webpack_public_path__ + "static/dag-logo-bg-461408410d17714e5077966f20a89f0c.png";